import React from 'react';
import CoreTeam from '@/components/CoreTeam/CoreTeam';

const CoreTeamPage: React.FC = () => {
    return (
        <section className='section2' id='ourteam'>
            <CoreTeam />
        </section>
    );
};

export default CoreTeamPage;